import { mut } from '@typek/signalhead';
import { writable, type Writable } from 'svelte/store';

export const timeRangeOptions = <const>['DAY', 'WEEK', 'MONTH'];
export type TimeRangeOption = 'DAY' | 'WEEK' | 'MONTH' | { custom: [Date, Date] };

export const currentTimeRange: Writable<TimeRangeOption> = writable('WEEK');

export const syncTimeRange$ = mut<boolean>(true);
